import axios from '@/api/config/request'
import { BASE_API } from './index'
const BoothApi = {
  list: (params) => {
    return axios.get(`${BASE_API}/booth/list`, { params })
  },
}
export default BoothApi